import React from 'react'
import "./dashboard.css"
import { Link } from 'react-router-dom'

const ProfileUpdated = () => {
    return (
        <div className='profile-updated'>
            <h6 className='text-secondary'>Profile Updated</h6>
            <div className="profile-completion-card profile-completion-card__small sc-jascpn gnhzFN">
                <div className="profile-completion-card--wrapper sc-hEXluy bHSkum" style={{ height: 200 }}>
                    <div style={{ display: 'flex' }} className='backgroundLight'>
                        <div className="profile-completion-card--image">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={144} height={122} viewBox="0 0 144 122" version={1}>
                                <g fill="none" fillRule="evenodd" transform="translate(2)">
                                    <circle cx={20} cy={101} r={5} fill="#FFF" fillRule="nonzero" stroke="#77D6F1" strokeWidth={2} />
                                    <circle cx={134} cy={65} r={6} fill="#FFF" fillRule="nonzero" stroke="#D4A2EB" strokeWidth={3} />
                                    <g transform="translate(23 7)">
                                        <g transform="translate(22 64)">
                                            <mask id="b" fill="#fff">
                                                <path d="M4 0h41c2 0 4 2 4 4v41a4 4 0 0 1-6 3l-17-7h-5L6 48a4 4 0 0 1-6-3V4c0-2 2-4 4-4z" />
                                            </mask>
                                            <path stroke="#72727D" d="M4 0l41-1c2 0 4 3 4 5v41a4 4 0 0 1-6 4l-17-7h-5L6 49a5 5 0 0 1-6-4V4c0-2 2-4 4-4z" />
                                            <path fill="#FFBEBA" fillRule="nonzero" stroke="#72727D" d="M-6 41V0l36-4-8 73-28-28z" mask="url(#b)" />
                                            <path fill="#FF9591" fillRule="nonzero" stroke="#72727D" d="M24 41V0l36-4-8 73-28-28z" mask="url(#b)" />
                                        </g>
                                        <path fill="#B8E1FF" stroke="#72727D" d="M6 51c2 2 2 4 1 7l-1 2a11 11 0 0 0 9 16h3c2 0 4 2 5 5l1 3c0 3 3 6 6 7 4 2 8 1 11-1l2-2h7l2 2c3 2 7 3 10 1 4-1 6-4 7-7l1-3c0-3 2-5 5-5h3c3 0 7-2 8-5 2-3 2-7 1-11l-2-2c-1-3 0-5 2-7l2-2a11 11 0 0 0-3-18l-3-1c-2-1-4-3-3-6v-3c0-4-1-7-4-10-3-2-6-3-10-2l-3 1c-2 1-5 0-6-2l-2-3a11 11 0 0 0-18 0l-1 3c-2 2-4 3-7 2l-2-1c-4-1-8 0-10 2-3 3-5 6-4 10v3c0 3-1 5-3 6l-3 1a11 11 0 0 0-3 18l2 2z" />
                                        <circle cx={47} cy={47} r={30} fill="#FFF" stroke="#72727D" />
                                        <path fill="#FAE400" fillRule="nonzero" stroke="#72727D" d="M65 45l-4 4-1 4v6l-2 3-3 1-6-2h-4l-5 2-4-1c-1-1-2-2-1-3v-6l-1-4-4-4-1-4 3-2 6-2 3-2 3-5 3-2 3 2 4 5 3 2 6 2 2 2v4z" />
                                    </g>
                                    <path stroke="#FFDBC9" strokeLinecap="round" strokeLinejoin="round" strokeWidth={4} d="M1 58l1-5c0-3 2-5 4-6v-1a10 10 0 0 0 4-6l2-6" />
                                    <path stroke="#FFD400" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M110 4l3 2 5 5c0 3 1 4 3 5l4 3" />
                                    <circle cx={30} cy={5} r={5} fill="#9EEBAF" fillRule="nonzero" />
                                    <path fill="#FFC3A5" d="M124 99l-5-2-2-4-2 4-5 2v1l5 2 2 5 2-5 5-2v-1z" />
                                </g>
                            </svg>
                        </div>
                        <div className="profile-completion-card--content">
                            <div>
                                <div className="profile-completion-card--title">
                                    <div>Your Profile is how your Matches</div>
                                    <div>see you. Thanks for improving it</div>
                                </div>
                            </div>
                            <div className="profile-completion-card--subtitle" style={{ marginTop: '38px' }}>Go ahead, check out your Matches</div>
                            <div className="sc-inlrYM hMWLuA" style={{ width: 'auto' }}>
                                <Link className="profile-completion-card--link" to="/todaysmatches">View Today’s Matches</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProfileUpdated
